import { Avatar, AvatarProps } from '@mui/material'

export interface IAcAvatar extends AvatarProps {}

export const AcAvatar = ({ children, ...props }: IAcAvatar) => {
  return <Avatar {...props}>{children}</Avatar>
}
